<script>
export default {
  name: 'App',
  computed: {}
};
</script>

<template>
  <div id="app">
    <router-view />
  </div>
</template>
